import React from 'react'
import AppDrawer from '@components/Sidebar/AppDrawer'
import Footer from '@components/organisms/Footer'
import Navigation from '@components/organisms/Navigation'
import { Category } from '@containers/Home/Category'
import {
  GetArticlesCategoryDocument,
  GetAdDistributionManagementDocument,
  AdDeliveryDestination,
} from '@services/graphcms/client'
import { initializeApollo } from '@graphql/apolloClient'
import { ArticleCategory } from '@services/coataz/constants'

export default function TopicsPage() {
  return (
    <>
      <AppDrawer>
        <Category category={ArticleCategory.topics} />
        <Footer />
        <Navigation />
      </AppDrawer>
    </>
  )
}

export async function getStaticProps() {
  const apolloClient = initializeApollo()

  const nextSeoValues = {
    title: '業界トピック | 塗料業界に特化した総合情報サイトのCOATAZ（コーターズ ）',
    description:
      '業界トピックに関する最新の情報はこちら。COATAZは塗料業界に特化したニュース、製品カタログや企業情報を掲載している塗料業界の総合情報サイトです。',
    canonical: 'https://coataz.com/topics',
    openGraph: {
      url: 'https://coataz.com/topics',
      title: '業界トピック | 塗料業界に特化した総合情報サイトのCOATAZ（コーターズ ）',
      description:
        '業界トピックに関する最新の情報はこちら。COATAZは塗料業界に特化したニュース、製品カタログや企業情報を掲載している塗料業界の総合情報サイトです。',
    },
  }

  await apolloClient.query({
    query: GetArticlesCategoryDocument,
    variables: {
      skip: 0,
      first: 15,
      category: 'topics',
      categoryTitle: 'topics',
    },
  })

  await apolloClient.query({
    query: GetAdDistributionManagementDocument,
    variables: {
      destination: AdDeliveryDestination.Top1,
    },
  })

  await apolloClient.query({
    query: GetAdDistributionManagementDocument,
    variables: {
      destination: AdDeliveryDestination.Top2,
    },
  })

  await apolloClient.query({
    query: GetAdDistributionManagementDocument,
    variables: {
      destination: AdDeliveryDestination.Top3,
    },
  })

  return {
    props: {
      initialApolloState: apolloClient.cache.extract(),
      nextSeo: nextSeoValues,
    },
    revalidate: 60,
  }
}
